/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useRef } from 'react';
import { navigate } from 'gatsby-link';
import { TrackingService } from '@rocheglobal/component-library/src/services/tracking';
import {
  CartService, PageStateContext, CommerceService, IProductMetadata, IProductMetadataError,
} from '../../services';
import { AnyProps } from '../types';
import { AdobeTracking } from '../../tracking';

interface AddToCartButtonProps extends AnyProps {
  blok: AddToCartButtonBlok;
}

interface AddToCartButtonBlok {
  component: string;
  /* The unique ID of the product metadata storyblok page */
  product: string;
  text: string;
}

export const AddToCartButton = (props: AddToCartButtonProps): JSX.Element => {
  const { cartLink } = useContext(PageStateContext);
  const { product } = props.blok;
  const element = useRef(null);
  const [isFetching, setisFetching] = React.useState(true);
  const [name, setName] = React.useState('');
  const [underline, setUnderline] = React.useState('');
  const [price, setPrice] = React.useState('');
  const [disabled, setDisabled] = React.useState(true);
  const [errorMessage, setErrorMessage] = React.useState(undefined);

  // DUE TO CHANGE
  /* NOTE: Because of the formed closure using UseEffect,
  add to cart is not able to access current state,
  one way of fixing this is using ref for dynamic values
  */
  const priceRef = useRef('');
  const nameRef = useRef('');

  const updatedData = {
    currency: 'EUR',
    items: [{
      item_id: product,
      item_name: nameRef.current,
      currency: 'EUR',
      discount: '',
      item_brand: 'Roche',
      item_category: 'Product',
      item_variant: '',
      price: priceRef.current,
    }],
  };

  // Separate data object for scAdd event with quantity
  const scAddData = {
    currency: 'EUR',
    items: [{
      item_id: product,
      item_name: nameRef.current,
      currency: 'EUR',
      discount: '',
      item_brand: 'Roche',
      item_category: 'Product',
      item_variant: '',
      price: priceRef.current,
      quantity: 1,
    }],
  };

  useEffect(() => {
    CommerceService.getProduct(product)
      .then((response: IProductMetadata) => {
        setName(response?.content?.name);
        setUnderline(response?.content?.underline);
        setPrice(response?.content?.price);
        setDisabled(false);
        setisFetching(false);
        // DUE TO CHANGE
        priceRef.current = response?.content?.price;
        nameRef.current = response?.content?.name;
      })
      .catch((error: IProductMetadataError) => {
        setErrorMessage(`${error.message || error.response} (${error.status})`);
        setisFetching(false);
      });

    const addToCartElement = element.current as HTMLElement;

    // eslint-disable-next-line @typescript-eslint/no-shadow
    const addToCart = (product: string): void => {
      setDisabled(true);
      CartService.addToCart(product, nameRef.current, priceRef.current)
        .then(() => navigate(cartLink))
        .then(() => {
          // DUE TO CHANGE
          TrackingService.push({
            event: 'add-to-cart',
            name: nameRef.current,
            page_path: window.location.pathname.startsWith('/') ? window.location.pathname.slice(1) : window.location.pathname,
            page_type: 'page',
            price: priceRef.current,
            project_name: 'roche-dot-de',
          } as any);
        })
        .catch(() => {
          setErrorMessage(CartService.errorMessage);
          setDisabled(false);
        });
    };

    addToCartElement?.addEventListener('rocheButtonClick', () => {
      AdobeTracking(scAddData, 'scAdd');
      setErrorMessage('');
      addToCart(product);
    });

    AdobeTracking(updatedData, 'prodView');
  }, []);

  return (
    <roche-add-to-cart
      ref={element}
      product-name={name}
      product-underline={underline}
      product-price={price.length > 0 ? priceRef.current : undefined}
      disabled={disabled}
      error={errorMessage}
      style={{ display: isFetching ? 'none' : 'block' }}
    />
  );
};
